// src/pages/PedidosAutomaticos/EnvioSAP.js
import React, { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';

const EnvioSAP = () => {
  const { get } = useApi();
  const [envios, setEnvios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEnvios = async () => {
      setLoading(true);
      try {
        const result = await get('PedidosEnvioSAP');
        setEnvios(result);
      } catch (err) {
        toast.error('No se pudieron cargar los envíos a SAP');
      } finally {
        setLoading(false);
      }
    };
    fetchEnvios();
  }, [get]);

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">Envío SAP de Pedidos Automáticos</h1>
      {loading && <p>Cargando...</p>}
      {!loading && envios.length === 0 && <p>No hay envíos disponibles.</p>}
      {!loading && envios.length > 0 && (
        <table className="w-full border rounded-lg text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border">ID</th>
              <th className="px-4 py-2 border">Pedido</th>
              <th className="px-4 py-2 border">SAP ID</th>
              <th className="px-4 py-2 border">Estado</th>
            </tr>
          </thead>
          <tbody>
            {envios.map((envio) => (
              <tr key={envio.id} className="hover:bg-gray-50">
                <td className="px-4 py-2 border">{envio.id}</td>
                <td className="px-4 py-2 border">{envio.pedido}</td>
                <td className="px-4 py-2 border">{envio.sapId}</td>
                <td className="px-4 py-2 border">{envio.estado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default EnvioSAP;
